


































































































































































































































import {Vue, Component, Prop} from 'vue-property-decorator'
import {OrbitProject} from '@/model/resource/OrbitProject'
import {EnvHelper} from '@/helpers/EnvHelper'
import {currentN3Network} from '@/helpers/NetworkModeRegistry'
import {TextHelper} from '@/helpers/TextHelper'

@Component({
  computed: {
    TextHelper() {
      return TextHelper
    },
    EnvHelper() {
      return EnvHelper
    },
  },
})
export default class OrbitPersistProjectReviewFormStep extends Vue {
  @Prop({type: OrbitProject, required: true}) orbitProject!: OrbitProject
  @Prop({type: String, required: true}) buttonText!: string

  /** RPC endpoints of the network picked in the network bar. */
  get activeRpcUrls(): string {
    return EnvHelper.rpcUrls(currentN3Network()).join(', ')
  }

  persistProject() {
    this.$emit('persist-project')
  }

  closeModal() {
    this.$emit('close')
  }
}
